import { Component, ViewChild } from '@angular/core';
import {
  ApiConfiguration,
  RouterService,
  StateService,
} from 'projects/shared/src/public-api';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { IonRouterOutlet, Platform } from '@ionic/angular';
import { App as CapacitorApp } from '@capacitor/app';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  @ViewChild(IonRouterOutlet, { static: true }) routerOutlet: IonRouterOutlet;
  sidebarCollapsed = false;
  constructor(
    private base: ApiConfiguration,
    private state: StateService,
    private platform: Platform,
    private routerService: RouterService
  ) {
    this.initializeApp();
  }

  async ngOnInit(): Promise<void> {
    if (window.location.href.includes('staging.baulogistik-app')) {
      this.base.rootUrl = environment.apiHostStaging;
      this.state.performHealthCheck();
    } else {
      this.base.rootUrl = environment.apiHost;
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Event wenn App wieder in den Vordergrund kommt
      CapacitorApp.addListener('appStateChange', async ({ isActive }) => {
        if (isActive) {
          console.log('App is in foreground');
          this.state.ensureTokenIsValid();
        } else {
          console.log('App is in background');
          this.state.lastDataUpdatedDate = new Date();
        }
      });
    });
  }
}
